import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError, formatCurrency } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

export default function WaiterTables() {
  const [tables, setTables] = useState([]);
  const navigate = useNavigate();

  const load = async () => {
    try { const { data } = await api.get("/tables"); setTables(data); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };

  useEffect(() => {
    load();
    const id = setInterval(load, 8000);
    return () => clearInterval(id);
  }, []);

  const openTable = async (t) => {
    try {
      const { data } = await api.post(`/tables/${t.id}/open`);
      navigate(`/waiter/tables/${t.id}?orderId=${data.id}`);
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };

  return (
    <div className="animate-fade-up" data-testid="waiter-tables-page">
      <p className="text-xs uppercase tracking-[0.3em] text-[#7248ae] mb-2">Tu salón</p>
      <h1 className="font-display text-3xl sm:text-4xl font-black text-[#1a0f2e] mb-6 tracking-tight">Mesas</h1>

      {tables.length === 0 && (
        <Card className="p-8 text-center border-dashed border-[#b182ec]/40">
          <p className="text-[#7248ae]">El administrador aún no ha dado de alta mesas.</p>
        </Card>
      )}

      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4" data-testid="waiter-tables-grid">
        {tables.map((t, i) => {
          const occupied = t.status === "occupied";
          const mine = occupied && t.current_waiter_id;
          return (
            <button
              key={t.id}
              onClick={() => occupied
                ? navigate(`/waiter/tables/${t.id}?orderId=${t.current_order_id}`)
                : openTable(t)
              }
              className={`text-left p-5 rounded-2xl border transition-all hover:-translate-y-1 active:scale-95 animate-fade-up stagger-${(i%6)+1} ${
                occupied ? "bg-[#3e166c] text-white border-[#3e166c]" : "bg-white text-[#1a0f2e] border-[#b182ec]/30"
              }`}
              data-testid={`waiter-table-${t.number}`}
            >
              <div className="flex items-start justify-between mb-3">
                <div>
                  <p className="text-xs uppercase tracking-wider opacity-70">Mesa</p>
                  <p className="font-display text-4xl font-black leading-none">{t.number}</p>
                </div>
                <Badge className={occupied ? "bg-white/20 text-white hover:bg-white/30" : "bg-[#10b981] text-white"}>
                  {occupied ? "Ocupada" : "Libre"}
                </Badge>
              </div>
              <p className={`text-xs ${occupied ? "text-white/80" : "text-[#7248ae]"}`}>
                {t.capacity} pers. · {t.location || "—"}
              </p>
              {occupied && (
                <div className="mt-3 pt-3 border-t border-white/20">
                  <p className="text-xs opacity-80">{t.current_waiter_name}</p>
                  <p className="font-display text-xl font-bold">{formatCurrency(t.current_total)}</p>
                </div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
